export default __webpack_public_path__ + "static/media/t22.e54cf997.jpg";